export enum SubDomain {
  Help = 'help',
  Publish = 'publish',
  WWW = 'www',
  Report = 'reports',
  OldReport = 'report',
}

const re = new RegExp(`(${Object.values(SubDomain).join('|')})?\\.?`, 'i');

const stripDoubleSlash = (path: string): string => path.replace(/\/\//g, '/');

export const getReportDomain = () => {
  try {
    const localDevBackend = import.meta.env.VITE_MONOLITH_APEX_DOMAIN;
    if (
      window.location.hostname.endsWith('.mynewsdesk.com') ||
      localDevBackend === 'mynewsdesk.com'
    ) {
      return 'https://reports.mynewsdesk.com';
    }
    if (
      window.location.hostname.endsWith('.mynewsdesk.test') ||
      localDevBackend === 'mynewsdesk.test' ||
      (!localDevBackend && window.location.hostname === 'localhost')
    ) {
      return 'http://localhost:4200';
    }
    return 'https://mnd-reports-staging.mynewsdesk.dev';
  } catch (e) {
    console.error(e);
    return 'https://reports.mynewsdesk.com';
  }
};

const mndUrl = (domain: SubDomain, path: string): string => {
  if (domain === SubDomain.Help) {
    return `https://help.mynewsdesk.com${stripDoubleSlash(path)}`;
  } else if (domain === SubDomain.Report) {
    return `${getReportDomain()}${stripDoubleSlash(path)}`;
  }

  const { protocol, port, hostname } = window.location;
  const portAppend = ['443', '80'].includes(port) ? '' : port;
  const replacedHostname = hostname
    .replace(re, `${protocol}//${domain}.`)
    .replace('publish.localhost', `localhost:${portAppend}`)
    .replace('www.localhost', `localhost:${portAppend}`);

  return `${replacedHostname}${stripDoubleSlash(path)}`;
};

export default mndUrl;
